export default __webpack_public_path__ + "static/media/upload-gray.1c674c74.svg";